import ApplicationSerializer from 'lumen/serializers/application';

export default class SubscriptionUserSerializer extends ApplicationSerializer {
  primaryKey = 'user_id';

  modelNameFromPayloadKey(key: string): string {
    if (key === 'data') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
      return super['modelNameFromPayloadKey']('subscription-users');
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    return super['modelNameFromPayloadKey'](key);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeQueryResponse(
    ...args: Parameters<ApplicationSerializer['normalizeQueryResponse']>
  ) {
    const payload = args[2] as Record<string, unknown>;
    if (payload && 'links' in payload) {
      delete payload['links'];
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    return super.normalizeQueryResponse(...args);
  }
}
